/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_BackInputs */

const en_import_back = /** @type {(inputs: Import_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to import`)
};

const de_import_back = /** @type {(inputs: Import_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zum Import`)
};

/**
* | output |
* | --- |
* | "Back to import" |
*
* @param {Import_BackInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_back = /** @type {((inputs?: Import_BackInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_BackInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_back(inputs)
	return en_import_back(inputs)
});